import * as React from 'react'
import styles from './optionLink-style.css'
import type { OptionLinkViewModel } from '../../../view-models/OptionLinkViewModel'
import Link from '../../Link/Link'
import type { GtagEvent } from '../../../utils/gtag'
type Props = OptionLinkViewModel & {
  eventMeta: GtagEvent
}

function OptionLink({ title, link, eventMeta }: Props) {
  return (
    <li className={styles.listItem}>
      <Link className={styles.optionLink} {...link} eventMeta={eventMeta} noUnderline hoverArrow>
        <div className={styles.title}>{title}</div>
      </Link>
    </li>
  )
}

OptionLink.displayName = 'OptionLink'
OptionLink.defaultProps = {}
export default OptionLink